import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteNotification } from '../api/notifications.api';

/**
 * Hook for deleting a single notification.
 * Invalidates notification queries on success.
 */
export const useDeleteNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};
